// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"b19e5e0c","213":"8d07902e","227":"57643e9f"}[chunkId] + ".chunk.css";
};